import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type InfolayerItemGenieChatEnd from 'webapp/models-custom/infolayer-item/genie-chat-end';

interface Args {
	model: InfolayerItemGenieChatEnd;
	onClose: () => void;
}

export default class InfolayerTypeGenieChatEndComponent extends Component<Args> {
	@action
	openChat(): void {
		this.args.model.open();
	}

	@action
	pauseExpiry(): void {
		this.args.model.pauseExpiry();
	}

	@action
	resumeExpiry(): void {
		this.args.model.resumeExpiry();
	}

	<template>
		<div
			role="status"
			class="infolayer infolayer--type-genie-chat-end {{@model.classes}}"
			{{on "mouseenter" this.pauseExpiry}}
			{{on "mouseleave" this.resumeExpiry}}
		>
			<div>
				<CommonUiIconComponent @name="Genie" @size="xl" @class="genie-icon" />
				<div class="content">
					<span class="title">{{@model.title}}</span>
					<p>{{@model.subtitle}}</p>
					<div class="controls2">
						<SubmitButtonComponent
							@text="Open chat"
							@noDelay={{true}}
							@onTrigger={{this.openChat}}
						/>
						<a class="close" role="button" {{on "click" @onClose}}>Dismiss</a>
					</div>
				</div>
			</div>
		</div>
	</template>
}
